module.exports = __webpack_public_path__ + "img/add_baby.0207f9b7.png";